module.exports = __webpack_public_path__ + "img/python.95df9761.svg";